/**
 * Reducer/Action Types
 */

export const LOAD_DATA = 'LOAD_DATA';
export const RESET_DATA = 'RESET_DATA';
export const UPDATE_BUNDLED_PRICING = 'UPDATE_BUNDLED_PRICING';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';



// WEBPACK FOOTER //
// ./app/config/types.js